import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Client - 客戶上傳單一檔案 (身分證正面以外的一般文件)
 */
const UploadSingleFile = [
    'POST',
    RouteUrlList.API_ClientUploadSingleFile.path,
    {},
    200,
    {
        status: true,
        title: '檔案上傳成功',
        message: '檔案已成功上傳',
        errorCode: '',
        result: {
            documentIdList: ['3fa85f64-5717-4562-b3fc-2c963f66afa6'],
            documentIdFirstOrDefault: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
            fileHash: '7a8b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b',
            mimeType: 'application/pdf'
        }
    }
];

export default UploadSingleFile;
